import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-beige/50 py-16 sm:py-24" data-id="element-32" data-mp="1cf02h7qgeyle">
      <div className="mx-auto max-w-3xl px-5" data-id="element-33" data-mp="1ccndwbq6xpzd">
        <SectionHeading eyebrow="Preguntas frecuentes" title="Resolvemos tus dudas" data-id="element-34" data-mp="2a2ia2f8dpunt" />

        <div className="mt-10 space-y-3" data-id="element-35" data-mp="252maqtammrel">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-beige bg-white shadow-sm" data-id="element-36" data-mp="202hsaxq5rmlq" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-cream/60" data-id="element-37" data-mp="opfbq2o26x1k">
                  <span className="font-display text-[15px] font-bold text-green-deep sm:text-base" data-id="element-38" data-mp="1pmtgchemcm0d">
                    {faq.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-green-brand transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-39" data-mp="1ap0yvjpihnjj" />
                </button>
                <AnimatePresence initial={false} data-id="element-40" data-mp="16np6j6f96o7n">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-41" data-mp="16ps8motok7sq">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-[#5A6656]" data-id="element-42" data-mp="mzykckq6cat9">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}